export default __webpack_public_path__ + "static/media/close.64f09d76.svg";